import { useAppDisplayModeContext } from '@archipro-design/aria';

import VideoSortDesktop from './VideoSort.desktop';
import VideoSortMobile from './VideoSort.mobile';
import type { PaginatedVideosProps } from '../../api/list-professional-videos.server';

export type VideoSortProps = Pick<PaginatedVideosProps, 'initialSort'> & {
    itemCount?: number;
};

const VideoSort: React.FC<VideoSortProps> = (props) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    if (isMobile) {
        return <VideoSortMobile {...props} />;
    }

    return <VideoSortDesktop {...props} />;
};

export default VideoSort;
